import { HTMLAttributes } from 'react';
import styled from 'styled-components';

export const Img = styled.img<HTMLAttributes<HTMLImageElement>>`
  margin: 0 auto 20px;
  display: block;
`;
